import React, { useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import axios from 'axios';
import './subscribe.css';

const SubscribeForNotification = ({ subscribeApiUrl }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [formLoading, setFormLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isError, setIsError] = useState(false);

    const subscriptionApiUrl = subscribeApiUrl || process.env.REACT_APP_SUBSCRIBE_API;

    const handleCloseModal = () => {
        setShowModal(false);
        setMessage("");
        setIsError(false);
        // Reset form after closing success modal
        if (!isError) {
            setEmail("");
            setValidated(false);
        }
    }

    const handleEmailAddress = (evt) => {
        let tempEmailAddress = evt.target.value;
        if (tempEmailAddress) {
            setEmail(tempEmailAddress.trim());
        } else {
            setEmail("");
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        const form = event.currentTarget;
        
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }
        
        setValidated(true);
        setFormLoading(true);
        
        // Build email JSON data
        const postBody = {
            emailAddress: email
        };
        
        axios
            .post(subscriptionApiUrl, postBody, {
                headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
                let bodyResponse = response.data;
                
                if (bodyResponse && bodyResponse.success) {
                    let successMsg = "";
                    
                    if (bodyResponse.success.emailAlreadySubscribed) {
                        successMsg = `Great news! You're already receiving our exclusive hotel offers and travel deals at ${email}.`;
                    } else if (bodyResponse.success.emailSubscribedNow) {
                        successMsg = `Welcome aboard! You'll now receive exclusive hotel deals, early-bird offers, and travel inspiration at ${email}.`;
                    } else {
                        successMsg = `Thank you for joining our travel community! Exciting offers coming your way soon.`;
                    }
                    
                    setMessage(successMsg);
                    setIsError(false);
                    setShowModal(true);
                    setFormLoading(false);
                    
                    // Clear form on success
                    setEmail('');
                    setValidated(false);
                    form.reset();
                }
            })
            .catch((error) => {
                console.error('Error in subscribe form: ', error);
                
                const errorMsg = `We couldn't subscribe your email (${email}). Please try again later.`;
                setMessage(errorMsg);
                setIsError(true);
                setShowModal(true);
                setFormLoading(false);
            });
    };

    return (
        <>
            <div className="subscribe-section">
                <Container>
                    <Row className="">
                    
                        <Col lg={12} md={12} sm={12} className="text-end d-flex justify-content-end">
                            <div className="subscribe-content">
                                <h2 className="subscribe-title">SUBSCRIBE</h2>
                                <p className="subscribe-subtitle">
                                    Sign up to receive news and updates.
                                </p>
                                
                                <Form
                                    id="subscribeForm"
                                    noValidate
                                    validated={validated}
                                    onSubmit={handleSubmit}
                                    className="subscribe-form"
                                >
                                    <div className="subscribe-form-wrapper">
                                        <Form.Group className="subscribe-input-group">
                                            <Form.Control
                                                type="email"
                                                placeholder="Email Address"
                                                value={email}
                                                onChange={handleEmailAddress}
                                                required
                                                pattern="^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]{2,64})$"
                                                className="subscribe-input"
                                                disabled={formLoading}
                                            />
                                            <Form.Control.Feedback type="invalid" className="email-feedback">
                                                Please enter a valid email address.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        
                                        <Button 
                                            type="submit" 
                                            className="subscribe-btn"
                                            disabled={formLoading}
                                        >
                                            {formLoading ? (
                                                <>
                                                    <Spinner
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className="me-2"
                                                    />
                                                    Signing up...
                                                </>
                                            ) : (
                                                'SIGN UP'
                                            )}
                                        </Button>
                                    </div>
                                </Form>
                                
                                <p className="subscribe-privacy">
                                    We respect your privacy.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Thank You / Error Modal */}
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                centered
                className="subscribe-modal"
            >
                <Modal.Header closeButton>
                   
                </Modal.Header>
                <Modal.Body>
                    <div className={`modal-message ${isError ? 'error-message' : 'success-message'}`}>
                        <h3 className='subscribe-msg'>{message}</h3>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant={isError ? "danger" : "success"} 
                        onClick={handleCloseModal}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SubscribeForNotification;